// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3884":"097afe4278d49c6a","4484":"749e9cf3c90bdb61","6677":"b76ae0a6467c67cf","6878":"5657c32e06476a2e","8032":"78f6772e914027aa"}[chunkId] + ".js";
};